// extracted by mini-css-extract-plugin
module.exports = {"productItem":"ProductItem_productItem__7J0nb"};